import { render, staticRenderFns } from "./contato.vue?vue&type=template&id=211294f8&scoped=true&"
import script from "./contato.vue?vue&type=script&lang=js&"
export * from "./contato.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap.min.css?vue&type=style&index=0&id=211294f8&scoped=true&lang=css&"
import style1 from "./contato.vue?vue&type=style&index=1&id=211294f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211294f8",
  null
  
)

export default component.exports